import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css', '../assets/global.css'],
    standalone: false
})
export class AppComponent {
  title = 'your-league-web';
}
